import React from 'react'
import {FooterHelp, Link, Page} from '@shopify/polaris'

import ItemListComponent from '../../components/item-list'

const Galleries = (props) => {
  return (
    <Page
      fullWidth
      title='Galleries'
      primaryAction={{
        content: 'Add Gallery',
        url: '/galleries/new'
      }}
    >
      <ItemListComponent
        resourceName={{
          singular: 'gallery',
          plural: 'galleries'
        }}
        endpoint={`/api/v2/admin/galleries`}
      />
      <FooterHelp>
        Learn more about<Link url="/docs#/create-your-first-gallery" external> creating your first gallery</Link>
      </FooterHelp>
    </Page>
  )
}

export default Galleries
